import type { Film } from "@/types/film";

export const genres = [
  "剧情",
  "悬疑",
  "犯罪",
  "爱情",
  "古装",
  "喜剧",
  "科幻",
  "家庭",
  "治愈",
];

export const years = [2025, 2024, 2023, 2022, 2021];

export const films: Film[] = [
  {
    id: "seoul-night-rain",
    title: "首尔夜雨",
    originalTitle: "서울의 밤비",
    year: 2024,
    genres: ["悬疑", "犯罪"],
    type: "电影",
    duration: "128分钟",
    rating: 8.7,
    region: "韩国",
    director: "金道允",
    cast: ["徐智安", "姜民浩", "文彩英", "罗允书"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20crime%20noir%20movie%20poster%20artwork%2C%20rain%20soaked%20Seoul%20alley%20at%20night%2C%20amber%20street%20lamps%20reflecting%20on%20wet%20asphalt%2C%20lone%20detective%20silhouette%20in%20long%20coat%2C%20deep%20teal%20and%20burnt%20orange%20color%20grading%2C%20subtle%20film%20grain%2C%20moody%20atmospheric%20lighting%2C%20no%20text%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=poster-seoul-night-rain&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rain%20drenched%20Seoul%20backstreet%20at%20midnight%2C%20wet%20cobblestone%20reflecting%20warm%20amber%20shop%20signs%2C%20distant%20figure%20walking%20with%20umbrella%2C%20teal%20blue%20shadows%20and%20orange%20highlights%2C%20shallow%20depth%20of%20field%2C%20anamorphic%20lens%20flare%2C%20no%20text%2C%20ultra%20detailed%20film%20photography&width=1600&height=900&seq=hero-seoul-night-rain&orientation=landscape",
    featured: true,
    tagline: "一场持续七天的夜雨，冲开了这座城市最安静的伤口。",
    synopsis:
      "连续七天的大雨笼罩首尔，一名负责失物招领的基层警员在深夜的派出所里收到一只被雨水泡胀的旧皮箱。皮箱里没有失主的线索，只有一叠十年前的手写日记和一张被撕掉一半的合影。随着调查推进，他发现日记中的每一个日期，都对应着城市里一件被草草结案的旧事。雨水冲刷掉的痕迹，恰恰是最不该被遗忘的部分。",
    details: [
      "影片以雨为叙事线索，用潮湿的街道、泛黄的灯管和几乎不说话的对话，构建出一种缓慢下沉的紧张感。导演金道允大量使用长镜头跟随主角穿过市场、天桥与地下通道，让观众与人物一同在城市的缝隙里寻找答案。",
      "故事没有把重心放在追凶本身，而是放在「记录」这件事上。主角一遍遍抄写日记、整理档案，像是在替这座迅速向前的城市保管记忆。结尾处雨停了，派出所门口的水洼映出清晨的光，留白克制却有力。",
      "配乐以钢琴与低音提琴为主，几乎不使用打击乐，却让每一次呼吸都显得沉重。这是一部需要耐心观看的作品，也是一部看完之后会在心里留很久的电影。",
    ],
    tags: ["雨夜美学", "悬疑推理", "城市记忆", "慢节奏"],
    updatedAt: "2025-09-18",
    views: "12.8万",
    status: "已完结",
  },
  {
    id: "han-river-winter",
    title: "汉江之冬",
    originalTitle: "한강의 겨울",
    year: 2023,
    genres: ["剧情", "家庭"],
    type: "剧集",
    duration: "单集60分钟",
    episodeCount: 16,
    rating: 8.9,
    region: "韩国",
    director: "李瑞妍",
    cast: ["申河琳", "白承宇", "尹佳恩", "崔允载"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20family%20drama%20poster%20artwork%2C%20frozen%20Han%20river%20at%20winter%20dusk%2C%20three%20figures%20standing%20apart%20on%20a%20snowy%20embankment%2C%20pale%20icy%20blue%20sky%20with%20warm%20orange%20window%20lights%2C%20quiet%20melancholic%20mood%2C%20soft%20film%20grain%2C%20no%20text%2C%20vertical%20composition%2C%20photorealistic&width=600&height=900&seq=poster-han-river-winter&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20winter%20scene%20of%20the%20Han%20River%20in%20Seoul%2C%20frozen%20water%20and%20snow%20covered%20riverbank%2C%20blue%20hour%20light%20with%20a%20band%20of%20warm%20amber%20glow%20at%20the%20horizon%2C%20distant%20apartment%20towers%20with%20lit%20windows%2C%20quiet%20melancholic%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20text%2C%20highly%20detailed%20photography&width=1600&height=900&seq=hero-han-river-winter&orientation=landscape",
    featured: true,
    tagline: "一条河，一个家，三代人没说完的话。",
    synopsis:
      "汉江边的一间老面馆即将拆迁，独自守店的女主人收到了三十年未联系的哥哥寄来的一把钥匙。钥匙打开的不是房子，而是一段被全家刻意绕开的往事。三代人的冬天在同一条江边重叠：上一辈的沉默、中间一代的远走，以及最小的一代试图重新学会说话的努力。",
    details: [
      "整部剧以四季中的「冬」为核心意象，每一集的开头都是一段江面的空镜，温度不同、光也不同。故事没有激烈的冲突，更多是把镜头放在饭桌、走廊、公交车站这些日常空间里，让观众自己在沉默中听出情绪。",
      "编剧用大量细节替代台词：一双总也洗不干净的旧筷子、冰箱里永远留着的一份小菜、门口补过三次的棉鞋。这些物件反复出现，构成了家庭内部最真实的时间刻度。",
      "最后一集，面馆的招牌被摘下，全家人在江边吃了一次迟到了很多年的饭。没有和解宣言，只有一句「汤要凉了」。被很多观众称为近年最克制的家庭剧结尾。",
    ],
    tags: ["家庭群像", "季节叙事", "生活流", "催泪"],
    updatedAt: "2025-09-21",
    views: "21.6万",
    status: "全16集",
  },
  {
    id: "jeju-spring",
    title: "济州岛的春天",
    originalTitle: "제주의 봄",
    year: 2024,
    genres: ["爱情", "剧情"],
    type: "电影",
    duration: "112分钟",
    rating: 8.2,
    region: "韩国",
    director: "朴成河",
    cast: ["文彩英", "罗允书", "韩志勋"],
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20film%20poster%20artwork%2C%20Jeju%20Island%20spring%20canola%20flower%20field%20with%20a%20stone%20wall%20and%20distant%20sea%2C%20two%20figures%20walking%20apart%20in%20soft%20morning%20haze%2C%20warm%20yellow%20and%20muted%20green%20palette%2C%20gentle%20sunlight%2C%20analog%20film%20texture%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=poster-jeju-spring&orientation=portrait",
    tagline: "她来这里告别，却遇见了另一个还没开始的人。",
    synopsis:
      "春天刚到济州岛，一位准备结束自己书店的城市编辑住进了海边的一间旧民宿。房东是一个话不多、每天清晨去海边捡石头的年轻人。两人原本只是短暂的交集，却在一次意外的停电夜里，聊起了各自不敢承认的失败。花开花落的一个月里，他们都试着重新回答「接下来要做什么」这个问题。",
    details: [
      "影片几乎全程在济州实景拍摄，镜头偏爱自然光与长时间的空景。油菜花田、黑色石墙、风大的海岸线，构成了一种温柔却不甜腻的视觉气质。",
      "两位主角的表演克制，很多情绪都停留在停顿与视线之间。导演刻意删掉了大部分配乐，只留下风声、脚步声和翻书声，让观众听见「春天」本身。",
      "影片并不承诺任何结果，结尾女主角把书店留在了岛上，独自坐船离开。那段没有对白的离别，被许多观众认为比任何告白都动人。",
    ],
    tags: ["济州实景", "治愈爱情", "慢电影", "春日"],
    updatedAt: "2025-08-30",
    views: "9.4万",
    status: "已完结",
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    originalTitle: "침묵의 증언",
    year: 2025,
    genres: ["犯罪", "悬疑"],
    type: "剧集",
    duration: "单集58分钟",
    episodeCount: 12,
    rating: 9.1,
    region: "韩国",
    director: "郑敏书",
    cast: ["姜民浩", "徐智安", "白承宇", "尹佳恩"],
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20series%20poster%20artwork%2C%20a%20hand%20signing%20in%20sign%20language%20in%20front%20of%20a%20blurred%20interrogation%20room%20window%2C%20stark%20blue%20and%20amber%20lighting%2C%20tense%20shadow%20patterns%2C%20minimal%20grainy%20composition%2C%20no%20text%2C%20vertical%20portrait%20framing%2C%20cinematic%20realism&width=600&height=900&seq=poster-silent-testimony&orientation=portrait",
    featured: true,
    tagline: "唯一的目击者不会说话，而凶手知道他签了什么。",
    synopsis:
      "一名聋人清洁工在深夜的写字楼里目击了一场伪装成意外的坠楼案。因为无法用语言陈述，她的证词在程序里一再被削弱、被改写、被怀疑。年轻检察官与手语翻译一同介入，才发现真正被消音的并不只是一段证词，而是整栋大楼里所有人都心照不宣的沉默。",
    details: [
      "全剧最大的特点是对声音的处理：在涉及聋人视角的段落里，环境音被大幅抽离，只剩低频震动与呼吸声，让观众直接体验「听不见」带来的失控感。",
      "剧本围绕「一个人说的话是否等于真相」展开，逐集拆解证据链。它不依赖夸张反转，而是靠细节累积制造压迫感，比如一段被剪掉三秒的监控、一次被替换的手语翻译。",
      "主演为角色进行了长达半年的手语训练，剧中所有手语段落均为演员本人完成。结尾的法庭戏几乎没有配乐，只留下手语在空气中划过的声音与观众的呼吸。",
    ],
    tags: ["社会派悬疑", "庭审", "手语", "高能反转"],
    updatedAt: "2025-10-12",
    views: "34.2万",
    status: "更新至第12集",
  },
  {
    id: "gwanghwamun-days",
    title: "光化门往事",
    originalTitle: "광화문의 세월",
    year: 2022,
    genres: ["古装", "剧情"],
    type: "剧集",
    duration: "单集65分钟",
    episodeCount: 20,
    rating: 8.5,
    region: "韩国",
    director: "崔允载",
    cast: ["白承宇", "申河琳", "韩志勋", "郑敏书"],
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20historical%20drama%20poster%20artwork%2C%20traditional%20palace%20gate%20at%20dusk%20with%20layered%20tile%20roofs%2C%20scholar%20in%20dark%20blue%20hanbok%20holding%20a%20scroll%2C%20warm%20lantern%20light%20and%20cool%20blue%20evening%20sky%2C%20painterly%20texture%2C%20no%20text%2C%20vertical%20composition%2C%20richly%20detailed%20costume%20drama%20aesthetic&width=600&height=900&seq=poster-gwanghwamun-days&orientation=portrait",
    tagline: "城门开合之间，一个时代被写进了史书，也被写进了谎话。",
    synopsis:
      "朝鲜王朝后期，一名负责整理宫廷文书的年轻史官发现，同一场政变在不同版本的记录里有着完全相反的写法。为了守住所见的真实，他在权力与笔之间反复权衡，也把身边所有人推向了危险。二十年后，当新的史官打开那批封存的册子，纸上留下的墨迹依然滚烫。",
    details: [
      "剧组搭建了完整的宫廷文书库场景，纸张、笔架、印泥均按史料复原。镜头经常停留在书写的特写上，让「落笔」成为全剧最有力量的行动。",
      "故事以文戏为主，朝堂辩论与私下的沉默形成鲜明对照。角色没有绝对的正邪，每个人都在自己的位置上做着一件自认为正确的事。",
      "结尾并没有给出结论，只留下一句旁白：「史书记得的事，未必都被看见。」这句台词也成为该剧播出后被引用最多的句子。",
    ],
    tags: ["史剧", "宫廷", "文人风骨", "群像"],
    updatedAt: "2025-07-14",
    views: "18.1万",
    status: "全20集",
  },
  {
    id: "gangnam-office",
    title: "江南办公室",
    originalTitle: "강남 오피스",
    year: 2024,
    genres: ["喜剧", "剧情"],
    type: "剧集",
    duration: "单集45分钟",
    episodeCount: 14,
    rating: 7.9,
    region: "韩国",
    director: "尹佳恩",
    cast: ["罗允书", "韩志勋", "文彩英", "姜民浩"],
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20workplace%20comedy%20series%20poster%20artwork%2C%20bright%20open%20plan%20office%20in%20Gangnam%20with%20glass%20walls%20and%20desks%2C%20four%20coworkers%20in%20slightly%20absurd%20poses%2C%20clean%20white%20interior%20with%20orange%20accent%20stationery%2C%20playful%20editorial%20photography%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=poster-gangnam-office&orientation=portrait",
    tagline: "在江南上班的第五年，他决定把工位变成一个小小的舞台。",
    synopsis:
      "一家中型广告公司的策划组，常年夹在大客户和总部指标之间。四个性格完全不同的同事，用各种离谱但有效的方式对抗无意义的会议、临时改稿和不回消息的甲方。笑闹之下，是每个职场人都不陌生的疲惫与坚持。",
    details: [
      "剧集以单元形式推进，每集围绕一个具体的职场荒诞事件展开：无效加班、团建、年终述职、突然空降的领导。荒诞被推到极致，反而显得格外真实。",
      "四位主角的化学反应是最大亮点，台词节奏接近情景喜剧，但情绪落点很稳。它不嘲笑努力的人，只嘲笑那些把努力当成消耗品的规则。",
      "结尾主角选择离职去做一间很小的独立工作室，没有逆袭，也没有宏大宣言，只是终于把「想做的事」写在了自己的日程表上。",
    ],
    tags: ["职场", "轻喜剧", "群像", "下饭剧"],
    updatedAt: "2025-08-02",
    views: "11.3万",
    status: "全14集",
  },
  {
    id: "platform-seven",
    title: "第七号月台",
    originalTitle: "일곱 번째 승강장",
    year: 2025,
    genres: ["科幻", "悬疑"],
    type: "电影",
    duration: "135分钟",
    rating: 8.8,
    region: "韩国",
    director: "金道允",
    cast: ["徐智安", "白承宇", "申河琳"],
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20sci%20fi%20mystery%20film%20poster%20artwork%2C%20empty%20subway%20platform%20with%20a%20single%20glowing%20clock%20showing%20midnight%2C%20tunnel%20fading%20into%20cool%20teal%20darkness%20with%20one%20amber%20emergency%20light%2C%20lone%20traveler%20silhouette%20with%20suitcase%2C%20symmetrical%20composition%2C%20subtle%20film%20grain%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=poster-platform-seven&orientation=portrait",
    featured: true,
    tagline: "每天零点，会有一班不存在的列车停靠在这座城市。",
    synopsis:
      "一名地铁信号工程师在检修时发现，系统里存在一条从未被录入的线路——第七号月台。每天零点，它会短暂出现三分钟，载走一些「本不该在这一天离开的人」。为了弄清楚十年前母亲失踪的真相，他开始一次次站上那个月台，也逐渐发现自己每一次上车，都在改写另一部分的人生。",
    details: [
      "影片用极简的场景完成复杂的时间结构：一条走廊、一个月台、一间信号控制室。重复的空间通过灯光与声音的细微变化被赋予不同时间层，观众需要像解谜一样辨认「这是第几次」。",
      "科幻设定服务于情感命题：如果可以选择回到某一天，你会带走谁，又会留下谁。影片没有给出标准答案，而是让主角在最后一次上车时，选择了不下车。",
      "声音设计极其出色，列车进站的轰鸣被处理成类似心跳的低频，越接近真相，节奏越慢。结尾黑幕后有三秒的持续低频，被影院观众称为「不敢立刻起身」的三秒。",
    ],
    tags: ["时间循环", "地铁", "硬设定", "情感内核"],
    updatedAt: "2025-10-05",
    views: "27.5万",
    status: "已完结",
  },
  {
    id: "spring-bento",
    title: "春日便当店",
    originalTitle: "봄의 도시락",
    year: 2023,
    genres: ["爱情", "治愈"],
    type: "剧集",
    duration: "单集42分钟",
    episodeCount: 16,
    rating: 8.4,
    region: "韩国",
    director: "李瑞妍",
    cast: ["文彩英", "尹佳恩", "罗允书"],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20Korean%20healing%20drama%20poster%20artwork%2C%20small%20neighborhood%20bento%20shop%20counter%20with%20wooden%20boxes%20of%20colorful%20food%2C%20soft%20spring%20morning%20light%20through%20a%20window%2C%20potted%20plants%20and%20handwritten%20paper%20notes%2C%20cream%20and%20warm%20orange%20palette%2C%20no%20text%2C%20vertical%20composition%2C%20cozy%20editorial%20photography&width=600&height=900&seq=poster-spring-bento&orientation=portrait",
    tagline: "每一份便当里，都藏着一句没说出口的话。",
    synopsis:
      "一间开在老街区拐角的小便当店，店主坚持每天只做三十份，而且必须由客人自己写下想要的口味。有人写「想吃小时候的味道」，有人写「想被谁等一次」。她一边做菜，一边听这些陌生人的故事，也慢慢把自己那段没能说完的告别重新热了一遍。",
    details: [
      "剧集采用「一集一便当」的结构，每道菜都对应一位客人的处境。食物拍摄极其讲究，油光、蒸汽、切开时的横截面都被细致记录，但并不喧宾夺主。",
      "店主的过去通过碎片式回忆展开，观众要看到中段才会明白她为什么坚持只做三十份。这个设定既是经营方式，也是她为自己划下的情绪边界。",
      "没有反派，也没有强冲突。它相信一顿热饭可以解决的事比想象中多，也承认有些事即使吃饱了也依然难过。",
    ],
    tags: ["美食", "治愈系", "慢生活", "单元剧"],
    updatedAt: "2025-06-22",
    views: "15.7万",
    status: "全16集",
  },
  {
    id: "white-night-chase",
    title: "白夜缉凶",
    originalTitle: "백야의 추적",
    year: 2024,
    genres: ["犯罪", "悬疑"],
    type: "剧集",
    duration: "单集55分钟",
    episodeCount: 10,
    rating: 8.6,
    region: "韩国",
    director: "郑敏书",
    cast: ["姜民浩", "徐智安", "韩志勋"],
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20crime%20investigation%20series%20poster%20artwork%2C%20detective%20standing%20under%20a%20harsh%20white%20streetlight%20in%20a%20narrow%20city%20alley%2C%20high%20contrast%20shadows%2C%20cold%20steel%20blue%20tones%20with%20a%20single%20amber%20warm%20window%2C%20gritty%20texture%2C%20no%20text%2C%20vertical%20portrait%2C%20cinematic%20realism&width=600&height=900&seq=poster-white-night-chase&orientation=portrait",
    tagline: "他追的凶手，总比他早一步知道下一个名字。",
    synopsis:
      "一桩尘封十七年的悬案重新出现，作案方式与当年完全一致，唯一的区别是这次凶手留下了警局内部的编号。被临时调回重案组的老刑警发现，所有线索都指向他当年的搭档。在追查与自证之间，他必须做出选择：相信证据，还是相信那个曾替他挡过刀的人。",
    details: [
      "剧集的节奏非常硬朗，每集结尾都停在一个新的疑点上。与传统刑侦剧不同的是，它把大量篇幅给了「程序」：审批、取证、复核，让真相的迟到显得更加真实。",
      "两位男主的对峙戏几乎占据了后半程，台词密度低但张力极高。很多关键情绪是通过两人对坐时谁先移开视线完成的。",
      "结局没有彻底清算所有问题，主谋被捕，但制度性的沉默仍然存在。最后一幕，主角把旧卷宗放回档案架，镜头缓缓拉远。",
    ],
    tags: ["刑侦", "双雄", "旧案重启", "硬核"],
    updatedAt: "2025-09-09",
    views: "19.8万",
    status: "全10集",
  },
  {
    id: "my-name-is-star",
    title: "我的名字是星",
    originalTitle: "내 이름은 별",
    year: 2022,
    genres: ["家庭", "剧情"],
    type: "电影",
    duration: "104分钟",
    rating: 8.1,
    region: "韩国",
    director: "朴成河",
    cast: ["尹佳恩", "申河琳", "罗允书"],
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20family%20drama%20film%20poster%20artwork%2C%20young%20girl%20with%20short%20hair%20looking%20through%20a%20foggy%20window%20at%20a%20city%20night%20sky%2C%20soft%20blue%20evening%20light%20with%20warm%20orange%20fairy%20lights%20reflected%20on%20glass%2C%20tender%20melancholic%20mood%2C%20analog%20grain%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=poster-my-name-is-star&orientation=portrait",
    tagline: "她被叫过很多名字，只有一个是自己取的。",
    synopsis:
      "十岁的小女孩在福利院与寄养家庭之间辗转，习惯用不同的名字介绍自己。一次偶然的夜间天文活动，让她看见了城市里几乎看不清的星。她决定给自己取一个不会更改的名字，并为了守住这个名字，做出一连串让大人都意外的事。",
    details: [
      "影片以孩子的视角展开，很多镜头高度低于成人视线，观众因此更容易注意到成年人忽略的角落与情绪。",
      "「名字」既是身份问题，也是归属问题。影片没有把寄养制度戏剧化，而是用几个极日常的场景——填表、点名、照相——呈现出孩子对稳定的渴望。",
      "结尾她在天文台的登记簿上郑重写下自己的名字，工作人员抬头笑着说「欢迎你，星」。很多人从这里开始哭。",
    ],
    tags: ["儿童视角", "成长", "家庭", "温柔"],
    updatedAt: "2025-05-30",
    views: "7.9万",
    status: "已完结",
  },
  {
    id: "train-in-fog",
    title: "雾中列车",
    originalTitle: "안개의 열차",
    year: 2021,
    genres: ["悬疑", "剧情"],
    type: "电影",
    duration: "121分钟",
    rating: 8.3,
    region: "韩国",
    director: "崔允载",
    cast: ["白承宇", "文彩英", "崔允载"],
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20Korean%20mystery%20film%20poster%20artwork%2C%20an%20old%20train%20emerging%20from%20thick%20fog%20on%20a%20single%20track%20through%20a%20pine%20forest%2C%20muted%20grey%20green%20atmosphere%20with%20a%20warm%20amber%20headlamp%20glow%2C%20lone%20platform%20figure%2C%20soft%20film%20grain%2C%20no%20text%2C%20vertical%20composition%2C%20cinematic%20photography&width=600&height=900&seq=poster-train-in-fog&orientation=portrait",
    tagline: "这趟列车上的乘客，都在等一个不会到站的人。",
    synopsis:
      "一趟因大雾停运却仍准时发车的旧线列车，载着七位目的不明的乘客。列车员发现所有人的车票日期都不同，却都指向同一天。随着雾越来越浓，车厢里的时间开始错位，他们必须在天亮前弄清楚：这趟车到底要把他们送到哪里。",
    details: [
      "影片几乎全部在移动的车厢内完成拍摄，靠窗外的雾、灯光与座椅的磨损程度暗示时间在变化。空间极小，悬念却层层展开。",
      "七位乘客各自带着一段未完成的关系，他们的对话像一场缓慢的互相审问。导演不让任何一个人成为纯粹的受害者，每个人都有隐瞒。",
      "结尾列车停在一片没有站牌的空地，乘客陆续下车。最后一个镜头是空车厢里仍在摇晃的窗帘，答案留给了观众。",
    ],
    tags: ["密闭空间", "群像悬疑", "雾", "文艺"],
    updatedAt: "2025-04-18",
    views: "8.6万",
    status: "已完结",
  },
  {
    id: "king-painter",
    title: "王的画师",
    originalTitle: "왕의 화공",
    year: 2023,
    genres: ["古装", "剧情"],
    type: "剧集",
    duration: "单集62分钟",
    episodeCount: 24,
    rating: 8.9,
    region: "韩国",
    director: "崔允载",
    cast: ["申河琳", "韩志勋", "白承宇", "尹佳恩"],
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20royal%20historical%20drama%20poster%20artwork%2C%20court%20painter%20in%20dark%20blue%20robes%20holding%20a%20brush%20before%20a%20large%20silk%20scroll%2C%20candlelit%20palace%20interior%20with%20amber%20glow%20and%20deep%20indigo%20shadows%2C%20ink%20and%20gold%20accents%2C%20painterly%20texture%2C%20no%20text%2C%20vertical%20composition%2C%20elegant%20detailed%20costume&width=600&height=900&seq=poster-king-painter&orientation=portrait",
    tagline: "他画下王的容貌，也画下了王不愿被看见的那一面。",
    synopsis:
      "被召入宫廷的年轻画师奉命绘制王的御容，却在一次次对坐中看见了与传闻完全不同的君主。画像是权力的象征，每一笔都可能成为罪证。当朝中有人要求他画出「该有的样子」时，他必须在笔与命之间做出选择。",
    details: [
      "全剧以绘画过程为叙事骨架，从研墨、起稿到设色，每一个步骤都对应一次人物关系的推进。观众等于跟着画师一起认识这位王。",
      "宫廷戏的分寸感很好，没有夸张的宫斗，权力更多通过站位、视线和沉默体现。画室成为全剧最安全也最危险的地方。",
      "最后一幅御容完成时，王问他：「你画的是我吗？」画师答：「是臣看见的您。」这句对白被认为是全剧的核心。",
    ],
    tags: ["宫廷画师", "人物志", "美学", "文戏"],
    updatedAt: "2025-03-26",
    views: "23.4万",
    status: "全24集",
  },
  {
    id: "samcheong-cat",
    title: "三清洞的猫",
    originalTitle: "삼청동의 고양이",
    year: 2025,
    genres: ["治愈", "剧情"],
    type: "剧集",
    duration: "单集38分钟",
    episodeCount: 12,
    rating: 8.0,
    region: "韩国",
    director: "尹佳恩",
    cast: ["文彩英", "罗允书", "崔允载"],
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20Korean%20healing%20series%20poster%20artwork%2C%20an%20orange%20tabby%20cat%20sitting%20on%20a%20stone%20wall%20in%20a%20quiet%20old%20Seoul%20neighborhood%20alley%2C%20traditional%20tile%20roofs%20and%20small%20cafe%20doorway%2C%20soft%20afternoon%20light%2C%20warm%20cream%20and%20terracotta%20palette%2C%20gentle%20film%20grain%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=poster-samcheong-cat&orientation=portrait",
    tagline: "这只猫每天换一家人蹭饭，也替他们保管秘密。",
    synopsis:
      "三清洞的巷子里住着一只被所有住户投喂的橘猫。它每天按固定路线巡街，停在哪家门口，哪家当天就会发生一点小事。十二集里，它见证了独居老人学会用视频通话、年轻夫妇重新商量要不要孩子，也把一个不敢回家的旅人带回了餐桌前。",
    details: [
      "剧集以猫的行进路线串联整条巷子，每集聚焦一户人家。镜头语言非常轻，几乎没有刻意的煽情，情绪都藏在一碗饭、一盏灯里。",
      "猫本身没有被赋予拟人化台词，它只是安静地出现、离开。正是这种不解释的陪伴，构成了全剧最动人的部分。",
      "最后一集，猫在冬天搬进了新开的书店，也就是第一集出现过的空店面。巷子里的生活继续，观众却已经认识了每一扇窗。",
    ],
    tags: ["动物", "邻里", "日常", "温暖"],
    updatedAt: "2025-10-15",
    views: "13.2万",
    status: "更新至第12集",
  },
  {
    id: "deep-sea-echo",
    title: "深海回声",
    originalTitle: "심해의 메아리",
    year: 2024,
    genres: ["科幻", "悬疑"],
    type: "电影",
    duration: "142分钟",
    rating: 8.7,
    region: "韩国",
    director: "金道允",
    cast: ["徐智安", "姜民浩", "申河琳"],
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20science%20fiction%20thriller%20film%20poster%20artwork%2C%20deep%20sea%20research%20submersible%20window%20with%20a%20faint%20amber%20light%20in%20black%20water%2C%20researcher%20silhouette%20reflected%20on%20glass%2C%20intense%20teal%20and%20navy%20palette%2C%20tiny%20particles%20floating%2C%20ominous%20atmosphere%2C%20no%20text%2C%20vertical%20composition%2C%20photorealistic&width=600&height=900&seq=poster-deep-sea-echo&orientation=portrait",
    tagline: "海底传来的信号，用的是她失踪丈夫的声音。",
    synopsis:
      "一支深海勘探队在朝鲜半岛以东的海沟里捕捉到一段重复了十一年的低频信号。负责声学分析的科学家惊讶地发现，信号里夹杂着人类语言，而那个声音属于她在一次事故中失踪的丈夫。为了确认来源，她申请下潜，却在更深处遇到了一个不该存在的研究站。",
    details: [
      "影片把大部分场景放在狭窄的潜水器与研究站内，幽闭感极强。水压、氧气余量和通讯延迟被反复强调，让科幻设定具备可信的物理重量。",
      "声音是真正的主角。全片有大量只有低频与心跳的段落，深海被表现为一种「有回应的空」。越接近信号源，环境音越像人声。",
      "结尾她没有返回水面，而是留在研究站继续发送信号。最后一帧是海面上漂浮的定位浮标，安静地闪了两下。",
    ],
    tags: ["深海", "硬科幻", "声音设计", "幽闭"],
    updatedAt: "2025-09-27",
    views: "16.5万",
    status: "已完结",
  },
  {
    id: "reverse-life",
    title: "逆向人生",
    originalTitle: "거꾸로 사는 사람",
    year: 2023,
    genres: ["剧情", "科幻"],
    type: "剧集",
    duration: "单集50分钟",
    episodeCount: 16,
    rating: 8.5,
    region: "韩国",
    director: "朴成河",
    cast: ["罗允书", "尹佳恩", "韩志勋"],
    poster:
      "https://readdy.ai/api/search-image?query=Surreal%20Korean%20drama%20poster%20artwork%2C%20a%20man%20walking%20up%20a%20staircase%20that%20folds%20into%20a%20clock%20face%2C%20warm%20amber%20light%20against%20deep%20navy%20background%2C%20floating%20calendar%20pages%20and%20a%20childhood%20toy%2C%20dreamlike%20composition%2C%20subtle%20grain%2C%20no%20text%2C%20vertical%20poster%2C%20elegant%20minimal%20surrealism&width=600&height=900&seq=poster-reverse-life&orientation=portrait",
    tagline: "从四十岁开始，他每天醒来都会更年轻一点。",
    synopsis:
      "一位四十岁的建筑师某天醒来，发现自己的时间开始倒着走：每一天身体与记忆都会退回更早的阶段。他无法向任何人解释，只能抓紧时间处理那些拖了很多年的事——道歉、告别、把没能说出口的话说出来。随着他越来越年轻，身边的人却越来越老。",
    details: [
      "剧集用「逆生长」的设定讨论遗憾，而不是卖弄奇观。每一集都会退回一个人生阶段，也带回一段没处理完的关系。",
      "主角与女儿的线是全剧核心。当他终于变成需要被照顾的年纪，女儿开始学着他当年的样子，替他系鞋带、读故事。",
      "最后他回到婴儿状态，镜头切到女儿在书桌前写下父亲的故事。时间没有变好，但被记录下来了。",
    ],
    tags: ["时间倒流", "亲情", "奇幻", "催泪"],
    updatedAt: "2025-02-11",
    views: "14.9万",
    status: "全16集",
  },
  {
    id: "last-kimchi",
    title: "最后的泡菜",
    originalTitle: "마지막 김치",
    year: 2022,
    genres: ["家庭", "喜剧"],
    type: "电影",
    duration: "98分钟",
    rating: 7.8,
    region: "韩国",
    director: "李瑞妍",
    cast: ["申河琳", "崔允载", "文彩英"],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20Korean%20family%20comedy%20film%20poster%20artwork%2C%20three%20generations%20crowded%20around%20a%20kitchen%20table%20making%20kimchi%2C%20large%20ceramic%20jars%20and%20red%20chili%20powder%2C%20sunlit%20rustic%20kitchen%20with%20warm%20cream%20and%20terracotta%20tones%2C%20joyful%20messy%20composition%2C%20no%20text%2C%20vertical%20portrait%2C%20editorial%20photography&width=600&height=900&seq=poster-last-kimchi&orientation=portrait",
    tagline: "为了守住一口老味道，这家人决定把整个院子都腌起来。",
    synopsis:
      "老宅即将拆迁，祖母坚持要在搬走前做完最后一次越冬泡菜。分散在各地的子女被迫回到同一个屋檐下，一边争论配方，一边把二十年的旧账翻了出来。做泡菜的几天里，争吵、笑声和辣椒粉一起飞满院子。",
    details: [
      "影片是标准的家庭喜剧结构，冲突密集但底色温柔。所有矛盾都围绕「谁的做法才对」展开，实际上争的是谁更被在意。",
      "食物拍摄极具感染力，腌料、白菜、陶缸的质感被拍得让人立刻想吃饭。很多观众表示看完必须点一份泡菜。",
      "结尾一缸泡菜被搬进新公寓的阳台，祖母说「味道会跟着人走」。全片最朴素的一句话，也是最有分量的一句。",
    ],
    tags: ["家庭喜剧", "美食", "三代同堂", "温暖"],
    updatedAt: "2025-01-20",
    views: "10.2万",
    status: "已完结",
  },
];

export const featuredFilmIds = [
  "seoul-night-rain",
  "silent-testimony",
  "platform-seven",
  "han-river-winter",
];